import { createSlice } from '@reduxjs/toolkit';
import { getScheduledBatches } from 'ducks/scheduled-batches/operators';
import { normalizeScheduledBatches } from 'ducks/scheduled-batches/utils';
import { Slices } from 'ducks/slices';
import { ScheduledBatch } from 'ducks/types/store-types';

export type ScheduledBatchesState = ScheduledBatch[];

const initialState: ScheduledBatchesState = [];

const scheduledBatchesSlice = createSlice({
  name: Slices.SCHEDULED_BATCHES,
  initialState,
  reducers: {
    updateScheduledBatches: (_, action) => {
      return action.payload;
    },
    clearScheduledBatches: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getScheduledBatches.pending, () => {
        return initialState;
      })
      .addCase(getScheduledBatches.fulfilled, (_, { payload }) => {
        return normalizeScheduledBatches(payload);
      })
      .addCase(getScheduledBatches.rejected, () => {
        return initialState;
      });
  },
});

export const { clearScheduledBatches } = scheduledBatchesSlice.actions;

export default scheduledBatchesSlice.reducer;
